(function () {
  const modalSelector = '[data-product-enquiry-modal]';
  const trackingStorageKey = 'diggerCityProductEnquiryPending';
  const scrollStorageKey = 'diggerCityProductEnquiryScroll';
  const pendingContactFormTypeKey = 'diggerCityPendingContactFormType';
  const pendingContactFormIdKey = 'diggerCityPendingContactFormId';
  const trackingExpiryMs = 30 * 60 * 1000;
  const allowedTrackingFields = [
    'product_title',
    'product_handle',
    'product_id',
    'variant_id',
    'sku',
    'price',
    'currency',
    'enquiry_region',
    'page_path',
    'product_url',
    'form_id',
    'event_timestamp',
  ];
  let activeModal = null;
  let activeTrigger = null;

  function sanitizeText(value, maxLength = 200) {
    return String(value || '')
      .replace(/[\u0000-\u001f\u007f]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, maxLength);
  }

  function sanitizeNumber(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : undefined;
  }

  function getCleanPath() {
    return window.location && window.location.pathname ? window.location.pathname : '';
  }

  function getCleanProductUrl(value) {
    const fallbackPath = getCleanPath();

    try {
      const url = new URL(value || fallbackPath, window.location.origin);
      return `${url.origin}${url.pathname}`;
    } catch (error) {
      return fallbackPath;
    }
  }

  function getSafeTimestamp(value) {
    const timestamp = Number(value);
    return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : Date.now();
  }

  function sanitizeTrackingPayload(payload) {
    const safePayload = {};

    allowedTrackingFields.forEach((field) => {
      if (!Object.prototype.hasOwnProperty.call(payload || {}, field)) return;

      if (field === 'price') {
        const price = sanitizeNumber(payload[field]);
        if (price !== undefined) safePayload[field] = price;
        return;
      }

      if (field === 'event_timestamp') {
        safePayload[field] = getSafeTimestamp(payload[field]);
        return;
      }

      if (field === 'page_path') {
        safePayload[field] = getCleanPath();
        return;
      }

      if (field === 'product_url') {
        safePayload[field] = getCleanProductUrl(payload[field]);
        return;
      }

      if (field === 'enquiry_region') {
        const region = sanitizeText(payload[field], 40);
        if (region === 'New Zealand' || region === 'International') {
          safePayload[field] = region;
        }
        return;
      }

      const textValue = sanitizeText(payload[field], field === 'product_title' ? 200 : 120);
      if (textValue) safePayload[field] = textValue;
    });

    return safePayload;
  }

  function publishDiggerCityEvent(eventName, payload) {
    const safePayload = sanitizeTrackingPayload(payload);
    const analytics = window.Shopify && window.Shopify.analytics;

    if (!analytics || typeof analytics.publish !== 'function') {
      if (window.DIGGER_CITY_ENQUIRY_TRACKING_DEBUG === true && window.console && typeof window.console.log === 'function') {
        window.console.log('Digger City enquiry event skipped', eventName, safePayload);
      }

      return false;
    }

    try {
      analytics.publish(eventName, safePayload);

      if (window.DIGGER_CITY_ENQUIRY_TRACKING_DEBUG === true && window.console && typeof window.console.log === 'function') {
        window.console.log('Digger City enquiry event', eventName, safePayload);
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  function getStoredPendingPayload() {
    try {
      const storedPayload = window.sessionStorage.getItem(trackingStorageKey);
      if (!storedPayload) return null;

      const pendingPayload = sanitizeTrackingPayload(JSON.parse(storedPayload));
      const pendingTimestamp = Number(pendingPayload.event_timestamp);

      if (!pendingTimestamp || Date.now() - pendingTimestamp > trackingExpiryMs) {
        window.sessionStorage.removeItem(trackingStorageKey);
        return null;
      }

      return pendingPayload;
    } catch (error) {
      return null;
    }
  }

  function removeStoredPendingPayload() {
    try {
      window.sessionStorage.removeItem(trackingStorageKey);
    } catch (error) {
      return;
    }
  }

  function storePendingPayload(payload) {
    const safePayload = sanitizeTrackingPayload(payload);

    try {
      window.sessionStorage.setItem(trackingStorageKey, JSON.stringify(safePayload));
    } catch (error) {
      return;
    }
  }

  function storeSubmitScrollPosition() {
    try {
      window.sessionStorage.setItem(scrollStorageKey, JSON.stringify({
        scrollY: Math.max(0, Math.round(window.scrollY || window.pageYOffset || 0)),
        event_timestamp: Date.now(),
      }));
    } catch (error) {
      return;
    }
  }

  function getStoredSubmitScrollPosition() {
    try {
      const storedPosition = window.sessionStorage.getItem(scrollStorageKey);
      if (!storedPosition) return null;

      const parsedPosition = JSON.parse(storedPosition);
      const scrollY = Number(parsedPosition.scrollY);
      const timestamp = Number(parsedPosition.event_timestamp);

      if (!Number.isFinite(scrollY) || scrollY < 0 || !timestamp || Date.now() - timestamp > trackingExpiryMs) {
        window.sessionStorage.removeItem(scrollStorageKey);
        return null;
      }

      return scrollY;
    } catch (error) {
      return null;
    }
  }

  function removeStoredSubmitScrollPosition() {
    try {
      window.sessionStorage.removeItem(scrollStorageKey);
    } catch (error) {
      return;
    }
  }

  function storePendingContactForm(formType, formId) {
    try {
      window.sessionStorage.setItem(pendingContactFormTypeKey, formType);
      window.sessionStorage.setItem(pendingContactFormIdKey, formId || '');
    } catch (error) {
      return;
    }
  }

  function getPendingContactForm() {
    try {
      return {
        type: window.sessionStorage.getItem(pendingContactFormTypeKey) || '',
        id: window.sessionStorage.getItem(pendingContactFormIdKey) || '',
      };
    } catch (error) {
      return { type: '', id: '' };
    }
  }

  function removePendingContactForm() {
    try {
      window.sessionStorage.removeItem(pendingContactFormTypeKey);
      window.sessionStorage.removeItem(pendingContactFormIdKey);
    } catch (error) {
      return;
    }
  }

  function getCleanContactSuccessUrl() {
    const currentUrl = new URL(window.location.href);
    const removableParams = [
      'contact_posted',
      'posted_successfully',
      'success',
      'contact_success',
    ];

    removableParams.forEach((param) => {
      currentUrl.searchParams.delete(param);
    });

    if (currentUrl.searchParams.get('form_type') === 'contact') {
      currentUrl.searchParams.delete('form_type');
    }

    if (/contact|success|posted|ProductEnquiryForm-|ProductShippingQuoteForm-/i.test(decodeURIComponent(currentUrl.hash.slice(1)))) {
      currentUrl.hash = '';
    }

    return currentUrl;
  }

  function refreshModalFromCleanUrl(modal) {
    if (!modal || !modal.id || typeof window.fetch !== 'function' || typeof window.DOMParser !== 'function') {
      return Promise.resolve(null);
    }

    const cleanUrl = getCleanContactSuccessUrl();

    return window.fetch(cleanUrl.href, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html) return null;

        const parsedDocument = new window.DOMParser().parseFromString(html, 'text/html');
        const freshModal = parsedDocument.getElementById(modal.id);
        if (!freshModal) return null;

        modal.replaceWith(freshModal);
        return freshModal;
      })
      .catch(() => null);
  }

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function getSection(modal) {
    return modal.closest('.main-product') || modal.closest('section') || document;
  }

  function getProductData(modal) {
    const section = getSection(modal);
    const productRoot = section.querySelector('[data-js-product]');
    const productJsonScript = productRoot ? productRoot.querySelector('.data-json-product') : null;
    const productJson = productRoot && productRoot.dataset.jsonProduct
      ? productRoot.dataset.jsonProduct
      : productJsonScript && productJsonScript.textContent;

    if (!productJson) return null;

    try {
      return JSON.parse(productJson);
    } catch (error) {
      return null;
    }
  }

  function getCurrentVariant(modal) {
    const section = getSection(modal);
    const productData = getProductData(modal);
    const variantInput = section.querySelector('[data-js-product-variant-input]');

    if (!productData || !Array.isArray(productData.variants) || !variantInput) return null;

    return (
      productData.variants.find((variant) => String(variant.id) === String(variantInput.value)) ||
      productData.variants.find((variant) => String(variant.id) === String(productData.default_variant_id)) ||
      productData.variants[0] ||
      null
    );
  }

  function getFieldValue(modal, fieldName) {
    const field = modal.querySelector(`[data-product-enquiry-field="${fieldName}"]`);
    return field ? field.value : '';
  }

  function getTrackingPayload(modal) {
    const productData = getProductData(modal) || {};
    const variant = getCurrentVariant(modal) || {};
    const price = variant.price !== undefined ? Number(variant.price) / 100 : modal.dataset.productPrice;

    return sanitizeTrackingPayload({
      product_title: modal.dataset.productTitle,
      product_handle: modal.dataset.productHandle || productData.handle,
      product_id: modal.dataset.productId || productData.id,
      variant_id: variant.id || modal.dataset.variantId,
      sku: variant.sku || modal.dataset.productSku || getFieldValue(modal, 'sku'),
      price,
      currency: modal.dataset.productCurrency || (window.theme && window.theme.currency) || window.shopCurrency,
      page_path: getCleanPath(),
      product_url: modal.dataset.productUrl,
      form_id: modal.dataset.productEnquiryFormId,
      event_timestamp: Date.now(),
    });
  }

  function getEnquiryRegion(form) {
    const selectedRegion = form.querySelector('input[name="contact[Enquiry Region]"]:checked');
    return selectedRegion ? selectedRegion.value : '';
  }

  function storePendingEnquiryPayload(form, modal) {
    const pendingPayload = getTrackingPayload(modal);
    pendingPayload.enquiry_region = getEnquiryRegion(form);
    pendingPayload.form_id = form.id || modal.dataset.productEnquiryFormId || '';
    pendingPayload.event_timestamp = Date.now();

    storePendingPayload(pendingPayload);
  }

  function formatMoney(cents) {
    const moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return (Number(cents) / 100).toFixed(2);
  }

  function syncModalFields(modal) {
    const variant = getCurrentVariant(modal);
    const productTitle = modal.dataset.productTitle || '';
    const defaultVariantLabel = modal.dataset.defaultVariantLabel || '';

    if (!variant) return;

    const variantTitle = variant.title && variant.title !== 'Default Title'
      ? variant.title
      : defaultVariantLabel || productTitle;

    modal.querySelectorAll('[data-product-enquiry-field="variant"]').forEach((field) => {
      field.value = variantTitle;
    });

    modal.querySelectorAll('[data-product-enquiry-field="sku"]').forEach((field) => {
      field.value = variant.sku || '';
    });

    modal.querySelectorAll('[data-product-enquiry-field="price"]').forEach((field) => {
      field.value = formatMoney(variant.price);
    });

    modal.dataset.variantId = variant.id || '';
    modal.dataset.productSku = variant.sku || '';
    modal.dataset.productPrice = variant.price !== undefined ? String(Number(variant.price) / 100) : '';
  }

  function getPhoneFields(modal) {
    return {
      phoneCodeField: modal.querySelector('[data-product-enquiry-phone-code-hidden]'),
      phoneCodeSelect: modal.querySelector('[data-product-enquiry-phone-code-select]'),
      phoneCodeCustom: modal.querySelector('[data-product-enquiry-phone-code-custom]'),
      phoneCodeCustomWrap: modal.querySelector('[data-product-enquiry-phone-code-custom-wrap]'),
      phoneNumberField: modal.querySelector('[data-product-enquiry-phone-number]'),
      fullPhoneField: modal.querySelector('[data-product-enquiry-phone-full]'),
    };
  }

  function sanitizePhoneCode(value) {
    const digits = String(value || '').replace(/\D/g, '').slice(0, 4);
    return digits ? `+${digits}` : '';
  }

  function sanitizePhoneNumber(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 14);
  }

  function getSelectedPhoneCode(fields) {
    if (!fields.phoneCodeSelect) return '+64';

    if (fields.phoneCodeSelect.value === 'other') {
      return sanitizePhoneCode(fields.phoneCodeCustom ? fields.phoneCodeCustom.value : '');
    }

    return sanitizePhoneCode(fields.phoneCodeSelect.value) || '+64';
  }

  function syncPhoneFields(modal, options = {}) {
    const fields = getPhoneFields(modal);

    if (!fields.phoneCodeSelect && !fields.phoneCodeCustom && !fields.phoneCodeField && !fields.phoneNumberField && !fields.fullPhoneField) {
      return;
    }

    if (fields.phoneCodeSelect && !fields.phoneCodeSelect.value && options.forceDefaultCountryCode) {
      fields.phoneCodeSelect.value = '+64';
    }

    const isOther = fields.phoneCodeSelect && fields.phoneCodeSelect.value === 'other';
    const phoneCodeValue = getSelectedPhoneCode(fields) || '+64';

    if (fields.phoneCodeSelect) {
      fields.phoneCodeSelect.required = true;
    }

    if (fields.phoneCodeCustomWrap) {
      fields.phoneCodeCustomWrap.hidden = !isOther;
      fields.phoneCodeCustomWrap.classList.toggle('is-hidden', !isOther);
      fields.phoneCodeCustomWrap.setAttribute('aria-hidden', isOther ? 'false' : 'true');
    }

    if (fields.phoneCodeCustom) {
      if (isOther) {
        fields.phoneCodeCustom.disabled = false;
        fields.phoneCodeCustom.required = true;
        fields.phoneCodeCustom.value = sanitizePhoneCode(fields.phoneCodeCustom.value);
      } else {
        fields.phoneCodeCustom.required = false;
        fields.phoneCodeCustom.disabled = true;
        fields.phoneCodeCustom.value = '';
      }
    }

    if (fields.phoneNumberField) {
      fields.phoneNumberField.value = sanitizePhoneNumber(fields.phoneNumberField.value);
    }

    if (fields.phoneCodeField) {
      fields.phoneCodeField.value = phoneCodeValue;
    }

    if (fields.fullPhoneField) {
      const combinedPhoneNumber = fields.phoneNumberField ? fields.phoneNumberField.value : '';
      fields.fullPhoneField.value = phoneCodeValue && combinedPhoneNumber ? `${phoneCodeValue} ${combinedPhoneNumber}` : '';
    }
  }

  function getInitialFocus(modal, trigger) {
    if (trigger) {
      return modal.querySelector('[data-product-enquiry-close]');
    }

    if (modal.dataset.productEnquiryState === 'success') {
      return (
        modal.querySelector('[data-product-enquiry-focus="success"]') ||
        modal.querySelector('[data-product-enquiry-close]')
      );
    }

    if (modal.dataset.productEnquiryState === 'error') {
      return (
        modal.querySelector('[data-product-enquiry-focus="error"]') ||
        modal.querySelector('.product-enquiry-modal__title') ||
        modal.querySelector('[data-product-enquiry-close]')
      );
    }

    return modal.querySelector('[data-product-enquiry-close]');
  }

  function openModal(modal, trigger, shouldFocus = true) {
    if (!modal) return;

    if (activeModal && activeModal !== modal) {
      closeModal(activeModal, false);
    }

    activeModal = modal;
    activeTrigger = trigger || null;
    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'true');
    }

    syncModalFields(modal);
    syncPhoneFields(modal, { forceDefaultCountryCode: true });
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('overflow-hidden');

    if (trigger) {
      publishDiggerCityEvent('digger_city:product_enquiry_opened', getTrackingPayload(modal));
    }

    if (!shouldFocus) return;

    const dialog = modal.querySelector('.product-enquiry-modal__dialog');
    const focusableElements = dialog ? getFocusableElements(dialog) : [];
    const initialFocus = getInitialFocus(modal, trigger) || focusableElements[0] || dialog;

    if (dialog && typeof trapFocus === 'function') {
      trapFocus(dialog, initialFocus);
    } else if (initialFocus) {
      initialFocus.focus();
    }
  }

  function closeModal(modal, restoreFocus = true) {
    if (!modal) return;

    const focusTarget = restoreFocus ? activeTrigger : null;
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(focusTarget);
    } else if (focusTarget) {
      focusTarget.focus();
    }

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
    }

    if (activeModal === modal) {
      activeModal = null;
      activeTrigger = null;
    }

    if (modal.dataset.productEnquiryState === 'success') {
      refreshModalFromCleanUrl(modal);
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-product-enquiry-trigger]');
    if (trigger) {
      event.preventDefault();
      const modal = document.getElementById(trigger.dataset.productEnquiryTarget);
      if (modal && modal.dataset.productEnquiryState === 'success' && !shouldOpenEnquiryModalOnLoad(modal)) {
        cleanupSuccessUrl(modal);
        refreshModalFromCleanUrl(modal).then((freshModal) => {
          if (freshModal) openModal(freshModal, trigger);
        });
        return;
      }
      openModal(modal, trigger);
      return;
    }

    const closeButton = event.target.closest('[data-product-enquiry-close]');
    if (closeButton) {
      const modal = closeButton.closest(modalSelector);
      closeModal(modal);
      return;
    }

    if (event.target.matches('[data-product-enquiry-overlay]')) {
      const modal = event.target.closest(modalSelector);
      closeModal(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!activeModal) return;

    if (event.code && event.code.toUpperCase() === 'ESCAPE') {
      event.preventDefault();
      closeModal(activeModal);
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-js-product-variant-input]')) return;

    const section = event.target.closest('.main-product') || event.target.closest('section');
    if (!section) return;

    section.querySelectorAll(modalSelector).forEach((modal) => {
      syncModalFields(modal);
    });
  });

  document.addEventListener('change', (event) => {
    const phoneCodeSelect = event.target.closest('[data-product-enquiry-phone-code-select]');
    if (!phoneCodeSelect) return;

    const modal = event.target.closest(modalSelector);
    if (!modal) return;

    syncPhoneFields(modal, { forceDefaultCountryCode: true });

    const fields = getPhoneFields(modal);
    if (fields.phoneCodeSelect && fields.phoneCodeSelect.value === 'other' && fields.phoneCodeCustom) {
      fields.phoneCodeCustom.focus();
    }
  });

  document.addEventListener('input', (event) => {
    const phoneCodeSelect = event.target.closest('[data-product-enquiry-phone-code-select]');
    const phoneCodeCustom = event.target.closest('[data-product-enquiry-phone-code-custom]');
    const phoneNumberField = event.target.closest('[data-product-enquiry-phone-number]');

    if (!phoneCodeSelect && !phoneCodeCustom && !phoneNumberField) return;

    const modal = event.target.closest(modalSelector);
    if (!modal) return;

    if (phoneCodeCustom) {
      phoneCodeCustom.value = sanitizePhoneCode(phoneCodeCustom.value);
    }

    if (phoneNumberField) {
      phoneNumberField.value = sanitizePhoneNumber(phoneNumberField.value);
    }

    syncPhoneFields(modal, { forceDefaultCountryCode: true });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.product-enquiry-form')) return;

    const modal = form.querySelector(modalSelector);
    if (!modal || modal.dataset.productEnquiryState !== 'normal') return;

    syncPhoneFields(modal, { forceDefaultCountryCode: true });

    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof form.reportValidity === 'function') {
        form.reportValidity();
      }
      return;
    }

    storePendingEnquiryPayload(form, modal);
    storePendingContactForm('enquiry', form.id || modal.dataset.productEnquiryFormId || '');
    storeSubmitScrollPosition();
  });

  function shouldRemoveSuccessHash(modal, currentUrl) {
    if (!currentUrl.hash) return false;

    const hashId = decodeURIComponent(currentUrl.hash.slice(1));
    const formId = modal.dataset.productEnquiryFormId;

    return (
      hashId === formId ||
      /^ProductEnquiryForm-/.test(hashId) ||
      /contact|success|posted/i.test(hashId)
    );
  }

  function restoreSubmitScrollPosition() {
    const storedScrollY = getStoredSubmitScrollPosition();
    const scrollY = storedScrollY !== null ? storedScrollY : 0;

    window.scrollTo({
      top: scrollY,
      left: window.scrollX || window.pageXOffset || 0,
      behavior: 'auto',
    });

    window.dispatchEvent(new Event('scroll'));
    removeStoredSubmitScrollPosition();
  }

  function cleanupSuccessUrl(modal) {
    if (!modal || modal.dataset.productEnquiryState !== 'success') return;

    const currentUrl = getCleanContactSuccessUrl();
    let replaced = false;

    if (shouldRemoveSuccessHash(modal, currentUrl)) {
      currentUrl.hash = '';
    }

    if (currentUrl.href !== window.location.href) {
      window.history.replaceState({}, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
      replaced = true;
    }

    if (replaced || getStoredSubmitScrollPosition() !== null) {
      window.requestAnimationFrame(() => {
        window.setTimeout(restoreSubmitScrollPosition, 0);
      });
    }
  }

  function publishConfirmedSubmission(modal) {
    if (!modal || modal.dataset.productEnquirySuccess !== 'true') return;

    const pendingPayload = getStoredPendingPayload();
    if (!pendingPayload) return;

    if (modal.dataset.productEnquiryFormId && pendingPayload.form_id !== modal.dataset.productEnquiryFormId) {
      removeStoredPendingPayload();
      return;
    }

    publishDiggerCityEvent('digger_city:product_enquiry_submitted', pendingPayload);
    removeStoredPendingPayload();
  }

  function shouldOpenEnquiryModalOnLoad(modal) {
    if (!modal) return false;

    if (modal.dataset.productEnquiryState === 'error') {
      return true;
    }

    if (modal.dataset.productEnquiryState !== 'success') {
      return false;
    }

    const pendingForm = getPendingContactForm();
    if (pendingForm.type !== 'enquiry') return false;

    if (modal.dataset.productEnquiryFormId) {
      return pendingForm.id === modal.dataset.productEnquiryFormId;
    }

    return false;
  }

  document.querySelectorAll(modalSelector).forEach((modal) => {
    syncPhoneFields(modal, { forceDefaultCountryCode: true });
    publishConfirmedSubmission(modal);
  });

  document.querySelectorAll(`${modalSelector}[data-product-enquiry-open-on-load="true"]`).forEach((modal) => {
    if (!shouldOpenEnquiryModalOnLoad(modal)) {
      cleanupSuccessUrl(modal);
      refreshModalFromCleanUrl(modal);
      return;
    }

    openModal(modal, null, true);
    cleanupSuccessUrl(modal);
    removePendingContactForm();
  });
})();
